module.exports = __webpack_public_path__ + "img/taochan.e5ce9f98.png";